/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { Grid } from "@mui/material";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Data
import ASNUploadController from "Controller/ASNUploadController";
import { Button, TextField, Typography } from "@mui/material";
import { Label, Upload } from "@mui/icons-material";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import MDInput from "components/MDInput";
// import { DataGrid } from "@mui/x-data-grid";

const ASNUpload = () => {
  const {
    PONumber,
    boxNumber,
    rows,
    columns,
    barcodes,
    alreadyUploadedBarcodes,
    notFoundBarcodes,
    errors,
    handleBarcodesChange,
    handleBarcodesPaste,
    clearBarcodes,
    getBarcodes,
    handleASNUpload,
  } = ASNUploadController();

  const footer = {
    opening_balance: "Total",
    debit: 1000,
    credit: 5000,
  };

  const [items, setItems] = useState([
    { id: "abc", aValue: 1 },
    { id: "def", aValue: 2 },
  ]);

  const handleChange = (e, id) => {
    const newVal = e.target.value;
    setItems((prev) => prev.map((item) => (item.id === id ? { ...item, aValue: newVal } : item)));
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3}>
                <Typography variant="h5" mb={1}>
                  PO Number: {PONumber} | Box Number: {boxNumber}
                </Typography>

                {/* Barcode upload text field */}
                <TextField
                  id="outlined-multiline-static"
                  label="Barcode Upload"
                  multiline
                  rows={5}
                  placeholder="Scan barcodes"
                  fullWidth
                  value={barcodes}
                  onChange={(e) => handleBarcodesChange(e)}
                  onPaste={handleBarcodesPaste}
                />

                {/* Barcode upload input error */}
                <Typography variant="span" style={{ color: "red", fontSize: "0.9rem" }}>
                  {errors.barcodes || ""}
                </Typography>

                <br />
                {/* Already uploaded barcodes */}
                <Typography variant="span" style={{ color: "saffron", fontSize: "0.9rem" }}>
                  {alreadyUploadedBarcodes?.length > 0 && "Barcodes Already uploaded: "}
                  {alreadyUploadedBarcodes.join(", ")}
                </Typography>

                <br />
                {/* Not Found Barcodes */}
                <Typography variant="span" style={{ color: "red", fontSize: "0.9rem" }}>
                  {notFoundBarcodes?.length > 0 && "Barcodes not found: "}
                  {notFoundBarcodes.join(", ")}
                </Typography>

                {/* Ok Button */}
                <MDBox my={1} sx={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                  <MDButton color={"dark"} onClick={(e) => getBarcodes()}>
                    Ok
                  </MDButton>

                  <MDButton color={"dark"} onClick={() => clearBarcodes()}>
                    Clear
                  </MDButton>
                </MDBox>

                {/* Barcode Table */}
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />

                {/* Upload Button */}
                <MDBox my={1} g={1} sx={{ display: "flex", justifyContent: "end" }}>
                  <MDButton color={"error"} onClick={() => handleASNUpload()}>
                    Submit
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
};

export default ASNUpload;
